import Crud from '../views/ModeloResposta/Crud'
import Entity from '../views/ModeloResposta/Add'

let routes = {
    path: '/modelo_respostas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/modelo_respostas/add',
            name: 'NewModeloResposta',
            component: Entity
        },
        {
            path: '/modelo_respostas/edit/:id?',
            name: 'EditModeloResposta',
            component: Entity
        },
        {
            path: '/modelo_respostas',
            name: 'list-modelo_respostas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Modelos de Resposta',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
